"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINTooltip = void 0;
var React = __importStar(require("react"));
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var PINTooltip = function (_a) {
    var id = _a.id, text = _a.text, _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children;
    return (React.createElement("div", { className: "pintooltip-container " + className },
        React.createElement("div", { "data-tip": true, "data-for": id, className: "pointer" }, children),
        React.createElement(react_tooltip_1.default, { id: id, class: "pintooltip", effect: "solid" }, text)));
};
exports.PINTooltip = PINTooltip;
//# sourceMappingURL=PINTooltip.js.map